import React, { useState } from 'react';
import { Modal } from '../common/Modal';
import { Calendar, Save } from 'lucide-react';
import { DefaultSchedule } from '../../types/movement';
import { useMovementStore } from '../../stores/movementStore';
import toast from 'react-hot-toast';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const DefaultScheduleModal = ({ isOpen, onClose }: Props) => {
  const { defaultSchedules, updateDefaultSchedules } = useMovementStore();
  const [schedules, setSchedules] = useState<DefaultSchedule[]>([
    {
      id: '1',
      name: 'موعد الذهاب الى المخيم',
      date: '10/01/2025',
      time: '12:00:00 PM'
    },
    {
      id: '2',
      name: 'موعد الرجوع من المخيم',
      date: '15/01/2025',
      time: '12:00:00 PM'
    },
    {
      id: '3',
      name: 'وقت تحرك الفنادق',
      time: '12:00:00 PM'
    },
    {
      id: '4',
      name: 'وقت التحرك من المخيم',
      time: '12:00:00 PM'
    },
    {
      id: '5',
      name: 'وقت تحرك المدينة',
      time: '12:00:00 PM'
    }
  ]);

  const handleSave = async () => {
    try {
      // Validate schedules
      for (const schedule of schedules) {
        if (schedule.date && !isValidDate(schedule.date)) {
          toast.error(`تاريخ غير صالح في ${schedule.name}`);
          return;
        }
        if (!isValidTime(schedule.time)) {
          toast.error(`وقت غير صالح في ${schedule.name}`);
          return;
        }
      }

      await updateDefaultSchedules(schedules);
      toast.success('تم حفظ المواعيد المعتادة بنجاح');
      onClose();
    } catch (error) {
      toast.error('فشل في حفظ المواعيد المعتادة');
    }
  };

  // Helper function to validate date format (dd/mm/yyyy)
  const isValidDate = (dateStr: string) => {
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/\d{4}$/;
    if (!regex.test(dateStr)) return false;
    
    const [day, month, year] = dateStr.split('/').map(Number);
    const date = new Date(year, month - 1, day);
    return date.getDate() === day && date.getMonth() === month - 1 && date.getFullYear() === year;
  };

  // Helper function to validate time format (hh:mm:ss AM/PM)
  const isValidTime = (timeStr: string) => {
    const regex = /^(0?[1-9]|1[0-2]):[0-5][0-9]:[0-5][0-9] (AM|PM)$/;
    return regex.test(timeStr);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="المواعيد المعتادة">
      <div className="space-y-6">
        <div className="flex items-center gap-2 text-primary-600">
          <Calendar size={20} />
          <span className="font-medium">تعديل المواعيد المعتادة للتحركات</span>
        </div>

        <div className="space-y-6">
          {schedules.map((schedule, index) => (
            <div key={schedule.id} className="bg-gray-50 p-4 rounded-lg">
              <div className="font-medium mb-3">{schedule.name}</div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Only show date input for camp schedules */}
                {schedule.name.includes('المخيم') && (
                  <div>
                    <label className="block text-sm text-gray-600 mb-1">التاريخ</label>
                    <input
                      type="text"
                      value={schedule.date || ''}
                      onChange={(e) => {
                        const newSchedules = [...schedules];
                        newSchedules[index] = {
                          ...schedule,
                          date: e.target.value
                        };
                        setSchedules(newSchedules);
                      }}
                      placeholder="dd/mm/yyyy"
                      className="w-full px-3 py-2 border rounded-lg text-right focus:ring-2 focus:ring-primary-500"
                    />
                  </div>
                )}

                <div>
                  <label className="block text-sm text-gray-600 mb-1">الوقت</label>
                  <input
                    type="text"
                    value={schedule.time || ''}
                    onChange={(e) => {
                      const newSchedules = [...schedules];
                      newSchedules[index] = {
                        ...schedule,
                        time: e.target.value
                      };
                      setSchedules(newSchedules);
                    }}
                    placeholder="hh:mm:ss AM/PM"
                    className="w-full px-3 py-2 border rounded-lg text-right focus:ring-2 focus:ring-primary-500"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
          >
            إلغاء
          </button>
          <button
            onClick={handleSave}
            className="flex items-center gap-2 px-6 py-2 bg-primary-500 text-white rounded-lg 
                     hover:bg-primary-600 transition-colors"
          >
            <Save size={18} />
            <span>حفظ التغييرات</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};